import React, { useEffect, useMemo } from 'react';
import { getAgreementProgressDetails } from './agreementUtils';
import '../styles/ProgressBar.css';

const AgreementProgressBarVisual = ({ agreement, userCommissions = 0, transactions = [], onComplete, styleType = 'standard', isLightBg = false }) => {
    // Usamos useMemo para evitar recalcular en cada render, a menos que los datos cambien.
    const details = useMemo(
        () => getAgreementProgressDetails(agreement, userCommissions, transactions), 
        [agreement, userCommissions, transactions]
    );

    const barWidth = details.progress || 0;
    const isInProfitZone = barWidth > 50;

    useEffect(() => {
        if (details.isComplete && agreement.status === 'aprobado' && onComplete) {
            onComplete(agreement);
        }
    }, [details.isComplete, agreement, onComplete]);
    
    if (!agreement) {
        return null;
    }

    if (styleType === 'detailed-card') {
        return (
            <div className={`progress-card-container-detailed ${isLightBg ? 'card-light-bg' : ''}`}>
                <div className="progress-percentage-header">
                    <span className="progress-display-text card-value-dark">
                        {(details.progress || 0).toFixed(1)}% <span className="progress-meta-text">de la meta</span>
                    </span>
                </div>

                <div className="progress-bar-superposed-wrapper">
                    <div className="progress-bar-background" />
                    <div className={`progress-bar-fill ${isInProfitZone ? 'profit-zone' : ''} ${details.isComplete ? 'complete' : ''}`} style={{ width: `${barWidth}%` }}/>
                </div>
            </div>
        );
    }

    // Standard style for tables
    return (
        <div className="progress-container-table">
            <div className="progress-bar-superposed-wrapper">
                <div className="progress-bar-background" />
                <div className={`progress-bar-fill ${isInProfitZone ? 'profit-zone' : ''} ${details.isComplete ? 'complete' : ''}`} style={{ width: `${barWidth}%` }} />
            </div>
            <span className="progress-value-table-side">{(details.progress || 0).toFixed(1)}%</span>
        </div>
    );
};

export default AgreementProgressBarVisual;
